/**
 * Describes a generic dictionary where the keys are strings
 */
export interface MapOf<T> {
    [key: string]: T;
}
